import { render, staticRenderFns } from "./CustomFiltersEditor.vue?vue&type=template&id=58978e2d&scoped=true&"
import script from "./CustomFiltersEditor.vue?vue&type=script&lang=js&"
export * from "./CustomFiltersEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomFiltersEditor.vue?vue&type=style&index=0&id=58978e2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58978e2d",
  null
  
)

export default component.exports